'use strict';

import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import CouponPropType from './CouponPropType.jsx';
import verifyCouponFromClient from '../../functions/verifyCouponFromClient';
import CurrencyPropType from './CurrencyPropType.jsx';
import StorageManager from 'ck-core-client/source/managers/StorageManager';
import storageAffiliateKey from '../../data/storageAffiliateKey';
import WebsiteFrame from '../../ui/system/WebsiteFrame';

export default function(WrappedComponent) {
	class WithCoupon extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				coupon: this.props.coupon
			};

			this.handleAffiliateSet = this.handleAffiliateSet.bind(this);
		}

		componentDidMount() {
			CK.moduleContainer.subscribe(WebsiteFrame.EVENTS.AFFILIATE_SET, this.handleAffiliateSet);

			if (!this.state.coupon) {
				this.handleAffiliateSet();
			}
		}

		componentWillUnmount() {
			CK.moduleContainer.unsubscribe(WebsiteFrame.EVENTS.AFFILIATE_SET, this.handleAffiliateSet);
		}

		componentDidUpdate(prevProps, prevState) {
			(async () => {
				const { affiliate } = this.state;

				if (!affiliate) {
					if (prevState.coupon) {
						this.setState({
							coupon: null
						});
					}
				} else if (!this.state.coupon || !this.state.coupon.id().startsWith(affiliate)) {
					this.verifyAndUpdateCoupon(affiliate);
				}
			})();
		}

		async verifyAndUpdateCoupon(code) {
			try {
				const { coupon } = await verifyCouponFromClient({
					code,
					currency: this.props.currency,
					planId: this.props.planId,
					hasHadAPlan: CK.user.hasHadAPlan()
				});

				this.setState({
					coupon
				});
			} catch (err) {
				CK.logger.info(err);
			}
		}

		handleAffiliateSet() {
			const affiliate = this.getAffiliateFromStorage();

			this.setState({
				affiliate
			});
		}

		getAffiliateFromStorage() {
			const storageManager = StorageManager.mod();
			return storageManager ? storageManager.get(storageAffiliateKey) : undefined;
		}

		render() {
			const props = _.defaults(
				{
					coupon: this.state.coupon
				},
				this.props
			);

			return <WrappedComponent {...props} />;
		}
	}

	WithCoupon.propTypes = {
		coupon: CouponPropType,
		currency: CurrencyPropType,
		planId: PropTypes.string
	};

	return WithCoupon;
}
